var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loader)?_c('div',{attrs:{"id":"preloader"}},[_vm._m(0)]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"status"}},[_c('div',{staticClass:"spinner-chase"},[_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"}),_c('div',{staticClass:"chase-dot"})])])
}]

export { render, staticRenderFns }